<template>
  <div class="home">
    <Header :articleId="articleId" />
    <div class="hd" id="hd">
      <template>
        <div v-if="btnShow && !preShow">
          <img :src="poster" alt="" class="poster" />
          <div class="play-btn">
            <img :src="playBtn" alt="" @click="handelPlay" />
          </div>
        </div>
        <div v-if="preShow">
          <img :src="poster" alt="" class="poster" />
          <div class="pre-time">
            直播时间：{{ liveBeginTime ? liveBeginTime : "暂无" }}
          </div>
        </div>
      </template>
      <video
        id="my-video"
        class="my-video"
        webkit-playsinline="true"
        playsinline="true"
        x5-playsinline="true"
        controls
        controlslist="nodownload"
        preload="auto"
      ></video>
    </div>
    <div class="intro-con">
      {{ summary }}
    </div>
    <div class="live-info">
      <div class="tab-list">
        <div
          :class="activeName === 1 ? 'list-active list-item' : ' list-item'"
          @click="activeName = 1"
        >
          精华回放
        </div>
        <div
          :class="activeName === 2 ? 'list-active list-item' : ' list-item'"
          @click="activeName = 2"
        >
          咨询讨论
        </div>
        <div
          :class="activeName === 3 ? 'list-active list-item' : ' list-item'"
          @click="activeName = 3"
        >
          高校资讯
        </div>
      </div>
      <div class="tab-info" v-show="activeName === 1">
        <Playback v-for="item in backList" :key="item.id" :listData="item" />
      </div>
      <div class="tab-info" v-show="activeName === 2">
        <Discuss v-for="item in discussList" :key="item.id" :listData="item" />
        <div class="wake-bt" @click="toApp">
          请在APP内查看更多评论、参与互动
        </div>
      </div>
      <div class="tab-info" v-show="activeName === 3">
        <News
          v-for="item in relatedList"
          :key="item.id"
          :listData="item"
          @toApp="toApp"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Hls from "hls.js";
import dayjs from "dayjs";
import Header from "../components/header.vue";
import Discuss from "../components/discuss.vue";
import Playback from "../components/playback.vue";
import News from "../components/news.vue";
import { wakeApp } from "@/utils/appMethods.js";
import { getArticle, getLiveComment, getComment } from "@/api/index.js";
import gzTrack from "@/utils/track.js";
import { H5WeChat_init } from "@/share/h5Share.js";
export default {
  components: {
    Playback,
    Discuss,
    News,
    Header,
  },
  data() {
    return {
      btnShow: true,
      preShow: false,
      poster: "",
      articleId: "",
      playBtn: require("@/assets/play.png"),
      activeName: 2,
      summary: "",
      shareDesc:"",
      videoUrl: "",
      title: "",
      discussList: [],
      relatedList: [],
      backList: [],
    };
  },
  created() {
    let articleId = this._getQueryString("articleId");
    this.articleId = articleId;
    this.getLiveComment(this.articleId);
    this.getComment(this.articleId);
    gzTrack(this.articleId);
  },
  mounted() {
    this.getArticle(this.articleId);
  },
  methods: {
    _getQueryString(name) {
      let reg = new RegExp("[?&]" + name + "=([^&#]*)", "i");
      let res = window.location.href.match(reg);
      if (res && res.length > 1) {
        return decodeURIComponent(res[1]);
      }
      return "";
    },
    handelPlay() {
      this.btnShow = false;
      let video = document.getElementById("my-video");
      video.play();
    },
    toApp() {
      wakeApp(this.articleId);
    },
    getArticle(articleId) {
      getArticle({ articleId: articleId }).then((res) => {
        if (res.data.code == 0) {
          console.log(res);
          this.relatedList = res.data.result.relatedList;
          this.summary = res.data.result.summary;
            this.shareDesc = res.data.result.shareDesc
            ? res.data.result.shareDesc
            : res.data.result.summary;
          this.title = res.data.result.shareTitle
            ? res.data.result.shareTitle
            : res.data.result.articleTitle;
          document.title = this.title;
          this.poster = res.data.result.coverImagesList.length
            ? res.data.result.coverImagesList[0].url
            : "";
          if (res.data.result.liveBeginTime) {
            //判断直播是否开始 开始显示播放按钮 未开播显示直播开始时间
            if (res.data.result.liveBeginTime > new Date().getTime()) {
              this.preShow = true;
            } else {
              this.preShow = false;
            }
          } else {
            this.preShow = true;
          }
          //this.preShow =res.data.result.liveBeginTime?res.data.result.liveBeginTim>new Date().getTime()?true:false:true
          this.liveBeginTime = res.data.result.liveBeginTime
            ? dayjs(res.data.result.liveBeginTime).format("MM-DD HH:mm")
            : false;
          console.log(this.preShow);
          let video = document.getElementById("my-video");
          H5WeChat_init({
            shareTitle: this.title,
            shareDesc: this.shareDesc,
            shareLink: window.location.href,
          });
          video.controls = true;
          if (res.data.result.liveBeginTime) {
            //判断直播是否结束 结束播放回放url  同时兼容2022以前数据
            if (dayjs(res.data.result.liveBeginTime).format("YYYY") == "2022") {
              if (res.data.result.liveEndTime < new Date().getTime()) {
                this.videoUrl = res.data.result.streams[0].backUrl;
              } else {
                this.videoUrl = res.data.result.streams[0].adr_original;
              }
            } else {
              this.videoUrl = res.data.result.streams[0].adr_original;
            }
          } else {
            this.videoUrl = res.data.result.streams[0].adr_original;
          }

          if (video.canPlayType("application/vnd.apple.mpegurl")) {
            // This will run in safari, where HLS is supported natively
            video.src = this.videoUrl;
          } else if (Hls.isSupported()) {
            // This will run in all other modern browsers
            const hls = new Hls();
            hls.loadSource(this.videoUrl);
            hls.attachMedia(video);
          } else {
            console.error(
              "This is an old browser that does not support MSE https://developer.mozilla.org/en-US/docs/Web/API/Media_Source_Extensions_API"
            );
          }
        }
      });
    },
    getLiveComment(articleId) {
      getLiveComment({ articleId: articleId }).then((res) => {
        if (res.data.code == 0) {
          this.backList = res.data.result.items;
        }
      });
    },
    getComment(articleId) {
      getComment({ articleId: articleId }).then((res) => {
        if (res.data.code == 0) {
          this.discussList = res.data.result.items;
          this.discussList = this.discussList.reverse();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  width: 750px;
  background-color: #fff;
  .hd {
    width: 750px;
    height: 420px;
    position: relative;
    .poster {
      z-index: 2;
      width: 750px;
      height: 420px;
      position: absolute;
      top: 0;
    }
    .play-btn {
      z-index: 3;
      background: rgba(0, 0, 0, 0.5);
      img {
        width: 100px;
        height: 100px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -50px;
        margin-top: -50px;
        z-index: 4;
      }
    }
    .pre-time {
      width: 400px;
      height: 70px;
      font-size: 24px;
      color: #fff;
      text-align: center;
      line-height: 70px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -200px;
      margin-top: -35px;
      border-radius: 35px;
      z-index: 4;
      background-color: rgba(44, 113, 193, 1);
    }
    .my-video {
      width: 100%;
      height: 100%;
    }
  }
  .intro-con {
    width: 690px;
    min-height: 64px;
    box-sizing: border-box;
    padding: 15px 24px;
    line-height: 1.5;
    margin: 16px auto 0;
    border-radius: 8px;
    text-align: left;
    color: rgba(68, 68, 68, 1);
    background: rgba(242, 243, 247, 1);
    font-size: 24px;
  }
  .live-info {
    margin-top: 8px;
    .tab-list {
      width: 750px;
      height: 92px;
      box-sizing: border-box;
      box-shadow: 0px -1px rgba(0, 0, 0, 0.08) inset;
      display: flex;
      justify-content: center;
      align-items: center;
      .list-item {
        width: 250px;
        height: 52px;
        box-sizing: border-box;
        color: rgb(68, 68, 68);
        font-size: 32px;
        font-weight: bold;
        text-align: center;
        line-height: 52px;
        cursor: pointer;
      }
      .list-active {
        color: rgba(44, 113, 193, 1);
      }
      .list-item:nth-child(1),
      .list-item:nth-child(2) {
        box-shadow: -1px 0px rgba(0, 0, 0, 0.12) inset;
      }
    }
    .tab-info {
      padding: 16px 30px;
      height: 55vh;
      overflow: scroll;
    }
  }
  .wake-bt {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    font-size: 28px;
    color: rgba(153, 153, 153, 1);
  }
}
</style>
